<template>
  <div class="row-fluid">
    <div class="container">
      <div class="row" v-if="paymentOptions.length > 1">
        <div class="col-xs-12" id="paytypes">
          <h3>{{ labels[1489] }}</h3>
          <!-- <template v-for="paymentOption in paymentOptions" :key="paymentOption.type"> todo vue3 -->
          <label
            v-for="paymentOption in paymentOptions"
            :key="paymentOption.type"
            :for="'type-' + paymentOption.type"
          >
            <input
              type="radio"
              name="payType"
              :id="'type-' + paymentOption.type"
              :value="paymentOption.type"
              v-model="method"
            />
            {{ paymentOption.label }}
          </label>
          <!-- </template> -->
        </div>
      </div>

      <!-- <hr v-if="paymentOptions.length > 1" /> -->

      <div class="row">
        <div class="col-xs-12"><!-- PAY DEFER--></div>
        <div class="col-xs-12" v-if="method == 'payPO'">
          <billing-purchase-order @billing-updated="setBillingStatus"></billing-purchase-order>
        </div>
        <div class="col-xs-12" v-if="method == 'payCreditCard'">
          <!-- <billing-card @billing-updated="true"></billing-card> -->
          <adyen-payments @stored-payment="handleStoredPayment"></adyen-payments>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 newAddress">
          <h3>{{ labels[1086] }}</h3>
          <div id="addressForm">
            <template v-if="loadingAddressForm">
              <h3 class="loadingText">
                <img src="/layouts/main/styles/images/spinner.gif" />
                Loading
              </h3>
              <div class="loadingOverlay"></div>
            </template>

            <Checkout-Address-Form mode="billing" />
            <div v-if="showUseAddressAsIs">
              <div class="alert alert-warning">
                <strong>{{ labels[2468] }}</strong>
                {{ labels[2571] }}
              </div>
              <button class="btn btn-primary btn-block btn-continue" @click="useAddressAsIs()">
                USE ADDRESS AS IS
                <span>&rsaquo;</span>
                <!-- USE ADDRESS AS IS -->
              </button>
            </div>
          </div>
        </div>

        <div class="col-lg-offset-2 col-lg-5 col-md-6 col-sm-6 col-xs-12 add-list">
          <Checkout-Address-Selector mode="billing" />
        </div>
      </div>
      <hr />
      <cart-footer>
        <template v-slot:left><div v-html="labels[1506]"></div></template>
        <template v-slot:center>
          <div v-html="labels[1507]"></div>
          <div class="alert alert-warning">
            <div v-html="labels[2570]"></div>
            <!-- By clicking "CONTINUE", you are agreeing to the terms and conditions. You are also agreeing... -->
          </div>
        </template>
        <template v-slot:right>
          <div class="priceDisplayBox">
            <Checkout-Total-Box />
          </div>
          <button
            rel="nofollow"
            :disabled="!canContinue"
            :class="continueBtnClass"
            class="btn btn-primary btn-block btn-continue"
            @click="proceedToNextStep"
            id="ship-address-next-vue"
          >
            {{ labels[1060] }}
            <span>&rsaquo;</span>
            <!-- CONTINUE -->
          </button>
        </template>
      </cart-footer>
    </div>
  </div>
</template>

<script>
  import { ref, computed } from '@vue/composition-api'
  import router from '../router'
  import CheckoutTotalBox from '../components/CheckoutTotalBox'
  import CartFooter from '../components/CartFooter'
  import CheckoutAddressForm from '../components/CheckoutAddressForm'
  import CheckoutAddressSelector from '../components/CheckoutAddressSelector'
  import AdyenPayments from '../components/AdyenPayments'
  import BillingPurchaseOrder from '../components/BillingPurchaseOrder'

  import useCMS from '../../shared/composables/useCMS'
  import useCheckoutAddresses from '../composables/useCheckoutAddresses'
  import useBilling from '../composables/useBilling'
  import useCheckout from '../composables/useCheckout'
  // import { use } from 'vue/types/umd'

  export default {
    name: 'CheckoutBilling',
    setup: function() {
      const { labels } = useCMS()
      let { loadingAddressForm, invalidAddress } = useCheckoutAddresses()
      const { getPaymentOptions, method, validateCard, paymentOptions } = useBilling()
      const { addresses, pricing } = useCheckout()
      const billingStatus = ref(false)
      let storedPayment = ref(false)
      let paymentMethodCondition = false

      const setBillingStatus = (event) => {
        billingStatus.value = event
      }
      billingStatus.value = true

      const canContinue = computed(() => {
        const billingCondition = billingStatus.value && addresses.value.billing.ID !== 'new'
        const shippingIDCondition =
          !isNaN(addresses.value.shipping.ID) && addresses.value.shipping.ID > 0
        paymentMethodCondition =
          method.value === 'payPO' || (method.value === 'payCreditCard' && storedPayment.value)
        if (
          billingCondition &&
          !invalidAddress.value &&
          shippingIDCondition &&
          addresses.value.shipping.VALID &&
          paymentMethodCondition
        ) {
          return true
        } else {
          return false
        }
      })

      const showUseAddressAsIs = computed(() => {
        const billingCondition = billingStatus.value && addresses.value.billing.ID !== 'new'
        const shippingIDCondition =
          !isNaN(addresses.value.shipping.ID) && addresses.value.shipping.ID > 0
        paymentMethodCondition =
          method.value === 'payPO' || (method.value === 'payCreditCard' && storedPayment.value)
        if (
          billingCondition &&
          invalidAddress.value &&
          shippingIDCondition &&
          addresses.value.shipping.VALID &&
          paymentMethodCondition
        ) {
          return true
        } else {
          return false
        }
      })

      const continueBtnClass = computed(() => (!canContinue.value ? 'disable' : ''))

      if (!paymentOptions.value.length) {
        getPaymentOptions()
      }

      const handleStoredPayment = (value) => {
        console.log('triggeredStoredPayment', value)
        billingStatus.value = value
        storedPayment.value = value
        console.log('storedPaymentValue', storedPayment.value)
      }

      const proceedToNextStep = () => {
        router.push('Review')
        // router.push('/checkout/review');
      }

      const useAddressAsIs = () => {
        invalidAddress.value = false
        billingStatus.value = true
        paymentMethodCondition = true
        return true
      }

      return {
        labels,
        loadingAddressForm,
        invalidAddress,
        addresses,
        method,
        validateCard,
        paymentOptions,
        billingStatus,
        canContinue,
        proceedToNextStep,
        setBillingStatus,
        pricing,
        handleStoredPayment,
        continueBtnClass,
        useAddressAsIs,
        showUseAddressAsIs,
      }
    },
    components: {
      CheckoutTotalBox,
      CartFooter,
      CheckoutAddressSelector,
      CheckoutAddressForm,
      AdyenPayments,
      BillingPurchaseOrder,
    },
  }
</script>
